import styled from 'styled-components'

export const TextArea = styled.textarea`
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 200px;
  max-height: ${(props) => (props.large ? '500px' : '200px')};
  min-height: 100px;
  margin-right: auto !important;
  margin-left: auto !important;
  padding: 7.5px;
  border: 2px solid #9abbbf;
  ${(props) => props.large && 'height: 300px;'}
`

export default TextArea



// WEBPACK FOOTER //
// ./src/components/atoms/input/TextArea.tsx